import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Shell for the no-sign-in request page: branding plus a way into staff
 * sign-in. No sidebar or bottom nav — everything behind them needs a session.
 */
export default function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh bg-surface">
      <header className="sticky top-0 z-20 bg-dcvfd-dark/95 backdrop-blur-sm">
        <div className="mx-auto flex max-w-2xl items-center justify-between px-4 py-2.5">
          <div className="flex items-center gap-3">
            <img src="/dcvfd-badge.svg" alt="DCVFD" className="h-8 w-auto" />
            <h1 className="text-base font-bold text-white tracking-tight">Supply Orders</h1>
          </div>
          <Link
            to="/login"
            aria-label="Settings — staff sign-in for logistics and admin"
            className="flex items-center gap-1.5 rounded-lg px-2 py-1.5 text-xs text-zinc-300 hover:bg-dcvfd/40 hover:text-white"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.75}
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.75}
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            Settings
          </Link>
        </div>
        <div className="h-0.5 bg-gradient-to-r from-dcvfd-accent/60 via-dcvfd-accent to-dcvfd-accent/60" />
      </header>
      <main>{children}</main>
    </div>
  );
}
